// extracted by mini-css-extract-plugin
module.exports = {"childCost":"styles_childCost__2nSzP","getquote":"styles_getquote__2rrCV"};